/*global OneDrive*/
import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'

import config from 'config'
import { normalizeOneDriveFiles } from 'helpers/pickerNormalizer'
import { getOneDriveFileTypesAccepted } from 'helpers/pickerFileTypesAcceptedProvider'

import styles from '../pick.scss'

class OnedrivePickerPick extends PureComponent {

	constructor() {
		super()
		this.onSuccess = this.onSuccess.bind(this)
		this.onCancel = this.onCancel.bind(this)
		this.onError = this.onError.bind(this)
		this.openPicker = this.openPicker.bind(this)
	}

	openPicker() {
		const options = {
			clientId: config.oneDrive.clientId,
			action: 'download',
			multiSelect: this.props.multiselect,
			advanced: {
				filter: getOneDriveFileTypesAccepted(this.props.accept),
				redirectUri: `${document.location.origin}/onedrive`,
			},
			success: this.onSuccess,
			cancel: this.onCancel,
			error: this.onError,
		}
		OneDrive.open(options)
	}

	onSuccess(files) {
		this.props.onChange(normalizeOneDriveFiles(files))
	}

	onCancel() {}

	onError() {}

	render() {
		return (
			<button styleName="picker-button" onClick={this.openPicker}>
				{this.props.children}
			</button>
		)
	}
}

export default CSSModules(OnedrivePickerPick, styles, {allowMultiple: true})
